(exports.GAME_ID = "63ab03af4941fd558c25c97d"),
(exports.FORM_ID = "63ab03af4941fd558c25c980"),
(exports.LINE_ITEM_ID = "60350a77a323940015f50a6c"),
(exports.UPDATE_ID = "63ab03af4941fd558c25c991"),
(exports.QUESTIONNAIRE_ID = "61f8f2b11c3efb0016bdf748"),
(exports.STATUS_ID = "61e04f7274d88d0016598ebd"),
(exports.SERVER_URL = "https://api-gabarit.promo.dev"),
(exports.BD_NAME = "odr-robot-husqvarna-voucher");